module.exports = __webpack_public_path__ + "static/media/SmartShop_4-256w.53cf3aff.png";